import PRIMARY_COLORS from '../colors/primary.js';
import PRIMARY_BORDER_RADIUS from '../borderRadius/primary.js';
import PRIMARY_BOX_SHADOWS from '../boxShadows/primary.js';
import PRIMARY_FONTS from '../fonts/primary.js';
import { PRIMARY_TYPOGRAPHY } from '../typography/primary.js';

var primaryTheme = {
  __type: 'primary',
  BORDER_RADIUS: PRIMARY_BORDER_RADIUS,
  BOX_SHADOWS: PRIMARY_BOX_SHADOWS,
  COLORS: PRIMARY_COLORS,
  FONTS: PRIMARY_FONTS,
  TYPOGRAPHY: PRIMARY_TYPOGRAPHY
};

export { primaryTheme };
